import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "text-lg font-semibold text-gray-900 mb-4 flex items-center" };
const _hoisted_2 = { class: "ml-auto flex items-center" };
const _hoisted_3 = {
    key: 0,
    class: "text-center py-4"
};
const _hoisted_4 = {
    key: 1,
    class: "text-red-600 bg-red-50 p-3 rounded-md"
};
const _hoisted_5 = {
    key: 2,
    class: "space-y-3 text-gray-700"
};
const _hoisted_6 = {
    key: 0,
    class: "flex items-center cursor-pointer p-3 border rounded-lg hover:bg-gray-50 transition-colors"
};
const _hoisted_7 = { class: "flex items-center justify-between w-full" };
const _hoisted_8 = { class: "text-sm text-gray-500" };
const _hoisted_9 = {
    key: 1,
    class: "flex items-center cursor-pointer p-3 border rounded-lg hover:bg-gray-50 transition-colors"
};
const _hoisted_10 = { class: "flex items-center justify-between w-full" };
const _hoisted_11 = { class: "text-sm text-gray-500" };
const _hoisted_12 = {
    key: 2,
    class: "flex items-center cursor-pointer p-3 border rounded-lg hover:bg-gray-50 transition-colors"
};
const _hoisted_13 = {
    key: 3,
    class: "text-center py-6 text-gray-500"
};
import { computed, ref, onMounted, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaymentMethodSelection',
    props: {
        modelValue: {},
        orderType: {},
        projectId: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const selectedValue = ref(props.modelValue);
        // State
        const isLoading = ref(false);
        const errorMessage = ref('');
        const paymentMethods = ref(null);
        // Load payment methods configuration
        const loadPaymentMethods = async () => {
            if (!props.projectId) {
                // Use default configuration if no projectId
                paymentMethods.value = {
                    cash: { enabled: true, availableFor: ['pickup', 'delivery', 'dine_in'], displayName: 'Barzahlung', description: 'Bei Abholung/Lieferung bezahlen' },
                    card: { enabled: true, availableFor: ['pickup', 'delivery', 'dine_in'], displayName: 'Kartenzahlung', description: 'Bei Abholung/Lieferung mit Karte bezahlen' },
                    paypal: { enabled: false, availableFor: [], displayName: 'PayPal', description: 'Online-Zahlung' },
                    bankTransfer: { enabled: false, availableFor: [], displayName: 'Überweisung', description: 'Zahlung per Banküberweisung' }
                };
                return;
            }
            isLoading.value = true;
            errorMessage.value = '';
            try {
                const response = await fetch('/api/orders/payment-methods');
                const data = await response.json();
                if (data.success && data.paymentMethods) {
                    paymentMethods.value = data.paymentMethods;
                }
                else {
                    throw new Error('Invalid response format');
                }
            }
            catch (error) {
                console.error('Error loading payment methods:', error);
                errorMessage.value = 'Fehler beim Laden der Zahlungsmethoden';
                // Use fallback configuration
                paymentMethods.value = {
                    cash: { enabled: true, availableFor: ['pickup', 'delivery', 'dine_in'], displayName: 'Barzahlung', description: 'Bei Abholung/Lieferung bezahlen' },
                    card: { enabled: true, availableFor: ['pickup', 'delivery', 'dine_in'], displayName: 'Kartenzahlung', description: 'Bei Abholung/Lieferung mit Karte bezahlen' },
                    paypal: { enabled: false, availableFor: [], displayName: 'PayPal', description: 'Online-Zahlung' },
                    bankTransfer: { enabled: false, availableFor: [], displayName: 'Überweisung', description: 'Zahlung per Banküberweisung' }
                };
            }
            finally {
                isLoading.value = false;
            }
        };
        // Check if payment method is available for current order type
        const isPaymentMethodAvailable = (method) => {
            if (!paymentMethods.value)
                return false;
            const methodConfig = paymentMethods.value[method];
            return methodConfig.enabled && methodConfig.availableFor.includes(props.orderType);
        };
        // Get available methods for current order type
        const availableMethods = computed(() => {
            if (!paymentMethods.value)
                return [];
            return Object.entries(paymentMethods.value).filter(([_, config]) => config.enabled && config.availableFor.includes(props.orderType)).map(([methodKey]) => methodKey);
        });
        function updateValue(value) {
            selectedValue.value = value;
            emit("update:modelValue", value);
        }
        const isComplete = computed(() => {
            return availableMethods.value.length > 0 && selectedValue.value && isPaymentMethodAvailable(selectedValue.value);
        });
        // Watch for prop changes
        watch(() => props.modelValue, (newValue) => {
            selectedValue.value = newValue;
        });
        // Auto-select first available method if none selected
        watch(availableMethods, (methods) => {
            if (methods.length > 0 && !selectedValue.value) {
                const firstMethod = methods[0];
                updateValue(firstMethod);
            }
        }, { immediate: true });
        // Load payment methods on mount
        onMounted(() => {
            loadPaymentMethods();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: _normalizeClass(["bg-white rounded-xl shadow-lg border-2 p-6 cursor-pointer hover:shadow-xl transition-shadow font-inter",
                    isComplete.value
                        ? 'border-green-200 bg-green-50 hover:border-green-300'
                        : 'border-gray-200 hover:border-red-100'
                ])
            }, [
                _createElementVNode("h3", _hoisted_1, [
                    _cache[6] || (_cache[6] = _createTextVNode(" Zahlungsmethode ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: _normalizeClass([
                                'w-2 h-2 rounded-full mr-2',
                                isComplete.value ? 'bg-green-500' : 'bg-gray-400',
                            ])
                        }, null, 2 /* CLASS */)
                    ])
                ]),
                (isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("div", { class: "inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-gray-900" }, null, -1 /* CACHED */),
                            _createElementVNode("p", { class: "text-gray-500 mt-2" }, "Lade Zahlungsmethoden...", -1 /* CACHED */)
                        ]))]))
                    : (errorMessage.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage.value), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createCommentVNode(" Cash Payment "),
                            (isPaymentMethodAvailable('cash'))
                                ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedValue).value = $event)),
                                        onChange: _cache[1] || (_cache[1] = ($event) => (updateValue('cash'))),
                                        type: "radio",
                                        value: "cash",
                                        class: "mr-3 text-green-600"
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelRadio, selectedValue.value]
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", null, [
                                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "font-medium" }, "Barzahlung", -1 /* CACHED */)),
                                            _createElementVNode("p", _hoisted_8, " Bei " + _toDisplayString(_ctx.orderType === "delivery" ? "Lieferung" : "Abholung") + " bezahlen ", 1 /* TEXT */)
                                        ]),
                                        _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-money-bills text-green-600 text-xl" }, null, -1 /* CACHED */))
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" Card Payment "),
                            (isPaymentMethodAvailable('card'))
                                ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedValue).value = $event)),
                                        onChange: _cache[3] || (_cache[3] = ($event) => (updateValue('card'))),
                                        type: "radio",
                                        value: "card",
                                        class: "mr-3 text-blue-600"
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelRadio, selectedValue.value]
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", null, [
                                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "font-medium" }, "Kartenzahlung", -1 /* CACHED */)),
                                            _createElementVNode("p", _hoisted_11, " Bei " + _toDisplayString(_ctx.orderType === "delivery" ? "Lieferung" : "Abholung") + " mit Karte bezahlen ", 1 /* TEXT */)
                                        ]),
                                        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-credit-card text-blue-600 text-xl" }, null, -1 /* CACHED */))
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" PayPal Payment "),
                            (isPaymentMethodAvailable('paypal'))
                                ? (_openBlock(), _createElementBlock("label", _hoisted_12, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedValue).value = $event)),
                                        onChange: _cache[5] || (_cache[5] = ($event) => (updateValue('paypal'))),
                                        type: "radio",
                                        value: "paypal",
                                        class: "mr-3 text-blue-600"
                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                        [_vModelRadio, selectedValue.value]
                                    ]),
                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex items-center justify-between w-full" }, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("span", { class: "font-medium" }, "PayPal"),
                                            _createElementVNode("p", { class: "text-sm text-gray-500" }, "Sofortige Online-Zahlung")
                                        ]),
                                        _createElementVNode("img", {
                                            src: "/paypal-logo.svg",
                                            alt: "PayPal",
                                            class: "h-6 w-auto"
                                        })
                                    ], -1 /* CACHED */))
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" No Payment Methods Available "),
                            (availableMethods.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-exclamation-circle text-3xl mb-2" }, null, -1 /* CACHED */)),
                                    _createElementVNode("p", null, "Keine Zahlungsmethoden verfügbar für " + _toDisplayString(_ctx.orderType === "delivery" ? "Lieferung" : "Abholung"), 1 /* TEXT */)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]))
            ], 2 /* CLASS */));
        };
    }
});
